import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bspop-over',
	templateUrl:'./BSPopOverPage.html',
	styles: [],
	styleUrls:['./BSPopOverPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSPopOverPage
{
	mdContent_144 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.popovers.BSPopOver;
\`\`\``;
	mdContent_145 = `\`\`\`java
new BSPopOver<>()
\`\`\``;
	mdContent_146 = `\`\`\`java
var popover = new BSPopOver<>();
popover.setPopOverTitle(new BSPopOverTitle<>().setText("Info"));
popover.setPopOverContent(new BSPopOverContent<>().setText("Details here."));
popover.setPlacement(BSPlacements.Top);
popover.setAnimation(true);
\`\`\``;
}
